var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      class: { disabled: _vm.uploadDisabled },
      staticStyle: { width: "100%" },
      attrs: {
        action: _vm.filePath,
        headers: _vm.header,
        name: "file",
        "list-type": "picture-card",
        "file-list": _vm.fileList,
        "show-file-list": true,
        "on-preview": _vm.handlePreview,
        "on-remove": _vm.handleRemove,
        "before-upload": _vm.handleBeforeUpload,
        "on-success": function (response, file, fileList) {
          return _vm.uploadSuccess(response, file)
        },
        data: { code: _vm.code },
      },
    },
    [
      _c("i", { staticClass: "el-icon-plus" }),
      _vm.instructionText
        ? _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip",
            },
            [_vm._v(_vm._s(_vm.instructionText))]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }